import {
  FETCH_ONCALL_ORDER_DETAIL_PENDING,
  FETCH_ONCALL_ORDER_DETAIL_REJECTED,
  FETCH_ONCALL_ORDER_DETAIL_FULFILLED,
  CLEAR_ONCALL_ORDER_DETAIL,
  SET_ID_ONCALL_ORDER_DETAIL
} from '../constants/oncallOrderDetail';

const initialState = {
  pending: true,
  oncallOrderDetail: {},
  error: {},
  success: false,
  customerID: null
};

export const onCallOrderDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ONCALL_ORDER_DETAIL_FULFILLED:
      return {
        ...state,
        oncallOrderDetail: action.data,
        pending: false,
        success: true,
      };

    case FETCH_ONCALL_ORDER_DETAIL_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_ONCALL_ORDER_DETAIL_PENDING:
      return { ...state, pending: true, success: false, error: {} };

    case SET_ID_ONCALL_ORDER_DETAIL:
      return { ...state, customerID: action.data };

    case CLEAR_ONCALL_ORDER_DETAIL:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/oncallOrderDetail.js